import classnames from 'classnames';
import IconNext from '@scramble/design-system/icons/chevron-right.svg?react';
import IconPrev from '@scramble/design-system/icons/chevron-left.svg?react';
import s from './index.module.scss';

export const SliderNavigation = ({ onNext, onPrev, className }) => (
  <div className={classnames(s.controls, className)}>
    <button
      type="button"
      className={classnames(s.prev)}
      onClick={() => onPrev()}
    >
      <IconPrev />
    </button>
    <button
      type="button"
      className={classnames(s.next)}
      onClick={() => onNext()}
    >
      <IconNext />
    </button>
  </div>
);
